module.exports = __webpack_public_path__ + "static/media/no-gender-user.678b1ebc.svg";